module.exports = __webpack_public_path__ + "static/media/siena.20f70a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siena.png
// module id = 315
// module chunks = 0